export const removeDuplicates = <T extends object>(
  myArr: T[],
  prop: keyof T
): T[] => {
  return myArr.filter((obj, pos, arr) => {
    return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos
  })
}
